import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {MixAndMatchSearchModel} from "../mix-and-match-search.model";
import {MixAndMatchSearchPageComponent} from "../mix-and-match-search-page/mix-and-match-search-page.component";
import {MixAndMatchEditPageComponent} from "../mix-and-match-edit-page/mix-and-match-edit-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";

@Component({
    selector: "wbo-mix-and-match-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(MixAndMatchSingleSelectEditControlComponent),
        provideSearchModel(MixAndMatchSearchModel)
    ]
})
export class MixAndMatchSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<MixAndMatchSearchModel> {
    constructor(model: MixAndMatchSearchModel, injector: Injector) {
        super(model, injector, "id", "name");

        this.extendedSearchComponent = MixAndMatchSearchPageComponent;
        this.extendedEditComponent = MixAndMatchEditPageComponent;
    }
}
